import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileField } from '../../types/profile';
import Field from '../forms/userData/Field';
import ModalWrapper from '../layouts/ModalWrapper';
import Button from '../misc/Button';

interface PrimaryEmailModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClick: (email: string) => void;
  emails: ProfileField[];
}

export default function PrimaryEmailModal({ open, setOpen, onClick, emails }: PrimaryEmailModalProps): JSX.Element {
  const [primary, setPrimary] = useState<ProfileField>();
  const { t } = useTranslation();
  return (
    <ModalWrapper
      open={open}
      setOpen={setOpen}
      className="h-a z-50 mx-6 w-fit min-w-[450px] max-w-[600px] rounded-3xl bg-secondary-50 px-10 py-6 pb-4 pt-5">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-medium">{t('modal.primaryEmail.title')}</h2>
        <p className="text-sm">{t('modal.primaryEmail.description')}</p>
      </div>

      <div className="mt-2 flex flex-col gap-2">
        {emails.map((email) => (
          <Field
            field={email}
            handleClick={(active, f) => (active ? setPrimary(undefined) : setPrimary(f))}
            active={email === primary}
          />
        ))}
      </div>
      <div className="mt-6 flex justify-end">
        <Button className="underline" onClick={() => setOpen(false)}>
          {t('general.cancel')}
        </Button>
        <Button variant="primary" className="px-[32px]" onClick={() => onClick(primary?.email!)}>
          {t('page.shared.acceptInvite')}
        </Button>
      </div>
    </ModalWrapper>
  );
}
